import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import EmployeeCareImage from "../assets/employeecare.png";

const EmployeeFirst = () => {
  return (
    <div className="employee-care-container">
      
      {/* What section */}
      <div className="employee-care-section">
        <h2 className="employee-care-heading">What is Employee First?</h2>
       
        <p className="employee-care-description">
          Employee First is our workplace mental wellness offering—designed to help organizations move beyond lip service and genuinely support their teams.
        </p>
        <p className="employee-care-description">
          This isn’t a generic wellness webinar or a one-time counseling hotline.
        </p>
        <p className="employee-care-description">
          It’s a real commitment to the emotional lives of your people—delivered through access, empathy, and care that’s always human.
        </p>
        <p className="employee-care-description">
          When people feel safe, seen, and supported, they don’t just work better—they live better.
        </p>
      </div>

      {/* How section */}
      <div className="employee-care-section">
        <h2 className="employee-care-heading">How Employee First works?</h2>
        <ul className="employee-care-list">
          <li>
            Unlimited access to Good Call: real-time support for everyday emotional moments
          </li>
          <li>
            Private therapy sessions through Clarity, with licensed professionals
          </li>
          <li>
            Customized mental wellness workshops built around your team’s real challenges
          </li>
          <li>
            Monthly emotional pulse reports (anonymous insights, real patterns)
          </li>
          <li>
            Psychometric tests to build emotionally intelligent teams and leaders
          </li>
        </ul>
      </div>

      {/* Why section */}
      <div className="employee-care-section employee-care-why">
        <h2 className="employee-care-heading">Why Employee First?</h2>
        <div className="employee-care-content">
          <div className="employee-care-features">
            {[
              "Boosts engagement, lowers burnout",
              "Builds a culture of psychological safety and trust",
              "Attracts and retains top talent—especially Gen Z and Millennials",
              "Positions your brand as genuinely people-first",
              "Backed by empathy, not just compliance",
            ].map((text, idx) => (
              <p key={idx} className="employee-care-feature">
                <FaCheckCircle className="employee-care-icon" /> {text}
              </p>
            ))}

          </div>

          <img
            src={EmployeeCareImage}
            alt="Employee Care Illustration"
            className="employee-care-image"
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeFirst;
